import styled from 'styled-components/macro';

export const Options = styled.div`
  padding: 15px;
  display: grid;
  grid-template-columns: 228px 228px;
  grid-gap: 0 15px;
  min-width: 258px;
  position: absolute;
  top: 42px;
  left: -23px;
  background: #181e33;
  box-shadow: inset 0px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 0px 0px 5px 5px;
  z-index: 999;
`;

export const Column = styled.div`
  padding: 15px;

  &:nth-child(2) {
    padding-left: 0;
  }
`;

export const Prefix = styled.div`
  width: 28px;
  height: 28px;
  border: 1px solid #fdfcfb;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: #fdfcfb;
  transition: 0.2s;
`;

export const Item = styled.a`
  width: 228px;
  display: flex;
  align-items: center;
  padding: 15px;
  cursor: pointer;
  border-bottom: 1px solid #8795a2;
  position: relative;

  &:last-child {
    border: none;
  }

  &:before {
    content: '';
    border-radius: 4px;
    position: absolute;
    top: 5px;
    bottom: 5px;
    right: 0;
    left: 0;
    background: rgba(255, 255, 255, 0);
    transition: 0.3s;
  }

  &:hover {
    text-decoration: none;

    ${Prefix} {
      background: #29a3c5;
      border: 1px solid #29a3c5;
      box-shadow: inset 0px 1px 5px rgba(0, 0, 0, 0.13);
    }

    &:before {
      background: rgba(255, 255, 255, 0.05);
    }
  }
`;
export const Title = styled.div`
  margin-left: 15px;
  font-family: 'Inter';
  color: #fdfcfb;
  font-size: 15px;
`;
